export const environment = {
    API_BOT: 'https://apichatbot.viettelmedia.vn',
    API_AUTHEN: 'https://minigame.congnap.vn',
    API_WS_BOT: 'https://wsbot.viettelmedia.vn/socket'
};
